// Mock content data for LRG Holdings (frontend-only). Later replaced by backend.

export const IMAGES = {
  heroSavanna: 'https://images.unsplash.com/photo-1589659647268-7803091f717b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000',
  acaciaSunset: 'https://images.unsplash.com/photo-1602685234860-3d38ee425ae8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  elephants: 'https://images.unsplash.com/photo-1564760055775-d63b17a55c44?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  acacia2: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  acacia3: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  diamondPolished: 'https://images.unsplash.com/photo-1599707367072-cd6ada2bc375?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  diamondBrilliant: 'https://images.unsplash.com/photo-1721919850259-2a15f09caeb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  diamondBlue: 'https://images.unsplash.com/photo-1664044020180-b75bfddf9776?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  diamondRough: 'https://images.unsplash.com/photo-1780432036547-39f627240c13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  uniCampus: 'https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  uniCampus2: 'https://images.unsplash.com/photo-1562774053-701939374585?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  graduation: 'https://images.unsplash.com/photo-1590012314607-cda9d9b699ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  lectureHall: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  squash1: 'https://images.unsplash.com/photo-1672068787369-82556699e538?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  squash2: 'https://images.unsplash.com/photo-1694723844104-a1495e30c7b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  squash3: 'https://images.unsplash.com/photo-1672068787390-ade92a1e30ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  eduStudents: '/images/edu-students.jpeg',
  botswanaJuniors: '/images/community-botswana-juniors.jpg',
  usTeam: '/images/community-us-team.jpg',
  bdfCommander: '/images/community-bdf-commander.jpg',
  eduParliament: '/images/edu-parliament-robinson.jpeg',
  communitySquashUsa: '/images/community-squash-usa.jpg',
  communitySoccerBotswana: '/images/community-soccer-botswana.jpg',
  versaceMelrose: '/images/versace-jeans-melrose.jpg',
  lefika: '/images/lefika-ragontse.jpeg',
  eduUbRobinson: '/images/edu-ub-robinson.jpeg',
  diamondsRobinson: '/images/diamonds-robinson.jpeg',
  eduHighCommission: '/images/edu-high-commission.jpg',
  leatherTexture: 'https://static.prod-images.emergentagent.com/jobs/37d36a11-e694-42f4-8923-17176365c91b/images/fb61cc76908b38a1d8360691d8cce085787becb650e5566e3bad4ea07f599ba5.jpeg',
  leatherBag: 'https://images.unsplash.com/photo-1549062572-544a64fb0c56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  leatherCraft: 'https://static.prod-images.emergentagent.com/jobs/37d36a11-e694-42f4-8923-17176365c91b/images/1f4e0bf2e2aa71dccdacd59f688249cb7d8a702a255d3abc1e77921d76360666.jpeg',
  cattle: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
};

export const COMPANY = {
  name: 'LRG Holdings',
  tagline: 'Bringing Botswana to the World',
  founder: 'Lefika Ragontse',
  email: 'lefikaragontse@lrgholdings.com',
  established: '2014',
  location: 'Gaborone, Botswana',
};

export const STATS = [
  { value: '4', label: 'Strategic Sectors' },
  { value: '3', label: 'Continents: Africa, North America, Europe' },
  { value: '2014', label: 'Founded in Gaborone' },
  { value: '100%', label: 'Botswana-Sourced Diamonds' },
];

export const ABOUT_PARAGRAPHS = [
  'LRG Holdings is a Botswana-based investment and development company founded in 2014 by Lefika Ragontse, focused on building enduring pathways that connect local industries to global opportunity. Our work spans diamonds, leather, education, and sports development, reflecting a commitment to growth, transparency, and long-term progress.',
  'Through partnerships with leading organisations in Botswana and abroad, LRG has helped attract investment, support youth employment, and contribute to sustainable economic development within local communities.',
  'Beyond commerce, we champion human capital: our squash foundation offers Botswana athletes the opportunity to pursue academic and athletic advancement at leading universities across the United States.',
];

export const PILLARS = [
  {
    id: 'diamonds',
    number: '01',
    title: 'Diamonds',
    subtitle: 'Botswana Brilliance',
    blurb: 'We source our diamonds exclusively from Botswana, a nation renowned for ethical and responsible mining, from rough to polished, with full traceability.',
    image: 'diamondsRobinson',
    focus: '35% 40%',
    to: '/diamonds',
  },
  {
    id: 'education',
    number: '02',
    title: 'Education',
    subtitle: 'Global Academic Bridges',
    blurb: 'LRG Holdings initiated and secured the signed partnership between the University of Botswana and the University of Chicago Harris School of Public Policy.',
    image: 'eduUbRobinson',
    focus: 'center 30%',
    to: '/education',
  },
  {
    id: 'community',
    number: '03',
    title: 'Community',
    subtitle: 'LRG Squash Foundation',
    blurb: 'Fostering youth development through sport, instilling life skills, promoting physical wellbeing, and paving pathways to higher education.',
    image: 'communitySoccerBotswana',
    focus: 'center 45%',
    to: '/community',
  },
  {
    id: 'leather',
    number: '04',
    title: 'Leather',
    subtitle: 'LRG Leather Botswana',
    blurb: 'A SEZA-licensed tanning and manufacturing export platform in Lobatse, capturing processing, design and export value within Botswana.',
    image: 'leatherTexture',
    to: '/leather',
  },
];

export const VALUES = [
  { title: 'Integrity', text: 'Ethical sourcing and transparent partnerships underpin every venture we undertake.' },
  { title: 'Legacy', text: 'We build for the long term, investing in institutions, industries, and people.' },
  { title: 'Opportunity', text: 'We create pathways that connect Botswana\u2019s talent and resources to the world.' },
];

export const DIAMOND_SERVICES = [
  {
    title: 'Rough Diamonds',
    body: 'With extensive expertise in the rough diamond trade, LRG Holdings facilitates the procurement of rough diamonds sourced from Botswana for clients worldwide. We provide dedicated, mandate-based representation for selected clients, from auction strategy and bidding through to the processing of acquired rough.',
    image: 'diamondRough',
    link: 'mailto:lefikaragontse@lrgholdings.com?subject=Rough%20Diamonds%20Enquiry',
    linkLabel: 'Enquire',
  },
  {
    title: 'Polished Diamonds',
    body: 'We are proud to offer a curated selection of polished diamonds, sourced exclusively from Botswana, the epitome of diamond excellence. Our specialisation lies in polished stones that meet our rigorous standards of cut, carat, clarity, and colour.',
    image: 'diamondBrilliant',
    link: 'https://www.botswana-brilliance.com',
    linkLabel: 'Botswana Brilliance',
  },
];

export const DIAMOND_TECH = [
  {
    partner: 'GemEx',
    body: 'LRG Holdings established its relationship with GemEx Systems to bring scientific light-performance analysis and advanced diamond-identification technology to Botswana Brilliance.',
    link: 'https://gemex.com/',
    status: '2023',
    logo: '/images/logo-gemex.svg',
  },
  {
    partner: 'iTraceiT',
    body: 'LRG Holdings partnered with iTraceiT to provide digital traceability and chain-of-custody capabilities for Botswana-origin diamonds.',
    link: 'https://itraceit.io/',
    status: '2024',
    logo: '/images/logo-itraceit.svg',
  },
  {
    partner: 'Sarine',
    body: 'LRG Holdings established its relationship with Sarine Technologies as part of the Botswana Brilliance verification and light-performance framework.',
    link: 'https://sarine.com/',
    status: '2026',
    logo: '/images/logo-sarine.svg',
  },
];

export const LEATHER = {
  licence: 'SEZBW00029',
  stats: [
    { value: '~1.7M', label: 'National cattle herd' },
    { value: 'BBB- / Baa1', label: 'Sovereign credit rating (investment grade)' },
    { value: '55+', label: 'Years of political stability' },
    { value: '5%', label: 'SEZ corporate tax, years 1 to 10' },
    { value: '35 ha', label: 'Lobatse Special Economic Zone' },
  ],
  why: [
    { title: 'The Gap', lines: ['Botswana exports raw hides.', 'Value is captured outside the country.'] },
    { title: 'The Opportunity', lines: ['Establish local tanning and finished goods manufacturing.', 'Capture processing, design and export margins domestically.'] },
    { title: 'The Outcome', lines: ['Industrial jobs.', 'Export revenues.', 'A scalable manufacturing base.'] },
  ],
  scope: ['Tannery (hide processing)', 'Finished goods manufacturing (bags, footwear, accessories)', 'Export-oriented production platform'],
  status: [
    ['Project structuring phase initiated', 'Active'],
    ['Engagement with SEZA under Lobatse SEZ framework', 'Active'],
    ['Raw material supply pathways under discussion with Botswana Meat Commission', 'Active'],
    ['International technical and manufacturing partners engaged', 'Active'],
  ],
  progress: [
    ['SEZA Investor Licence No. SEZBW00029 (16 Mar 2026, 50-year validity)', 'Granted'],
    ['Land allocation discussions in Lobatse SEZ', 'Underway'],
    ['Technical partnership agreement with Italprogetti S.p.A.', 'Signed'],
    ['Financial structuring and investment documentation', 'Underway'],
    ['BPC grid connection agreement for solar infrastructure', 'Next Required'],
    ['BERA licensing approval for IPP operations', 'Next Required'],
  ],
  environment: [
    { tag: 'Under Evaluation', title: 'Tanning Chemistry', text: 'Chrome-free, wet-white and vegetable-tanning chemistries are under active review. Final selection will follow anchor off-take specification.' },
    { tag: 'Non-Negotiable', title: 'Water and Effluent', text: 'On-plot effluent treatment, sludge management and water recycling designed to Italian tannery-cluster standards.' },
    { tag: 'By Design', title: 'Traceability', text: 'Multi-country SADC hide intake with hide-level documentation of origin, veterinary zone, cure method and weight class.' },
    { tag: 'Targeted', title: 'Certifications', text: 'Leather Working Group, ZDHC chemistry alignment, SEZA environmental compliance and Department of Environmental Affairs sign-off.' },
  ],
  partners: [
    { code: 'LRG', name: 'LRG Holdings', role: 'Project structuring and execution leadership' },
    { code: 'SEZA', name: 'SEZA', role: 'Industrial framework and licensing engagement' },
    { code: 'INT', name: 'International Partners', role: 'Technical expertise, manufacturing capability, product development' },
    { code: 'INV', name: 'Investors', role: 'Capital participation at SPV level' },
  ],
  technical: {
    name: 'Italprogetti S.p.A.',
    sub: 'Tuscan Tannery Engineering',
    facts: [['Founded', '1977'], ['Location', 'San Romano, Pisa, Italy'], ['Membership', 'Leather Working Group'], ['Engagement', 'Agreement Signed']],
    text: 'Phase 1 engineering and plant design is being delivered with Italprogetti under a signed technical partnership agreement. Italprogetti is one of the reference global suppliers of tannery drum, water-treatment and process-automation systems. The Tuscan leather cluster is the technical benchmark for luxury and automotive-grade leather worldwide, and the same specification standard is intended here.',
    tags: ['Tannery drums', 'Water treatment', 'Process automation', 'Sludge management', 'Gas treatment'],
  },
  investment: { round: 'USD 5 to 15M', label: 'Anchor Round', text: 'Phase 1 site development, technical partnership engagement and SPV-level pre-construction workstreams. Instrument, tranching and drawdown schedule to be structured with the anchor investor. Blended-finance and DFI participation welcomed.', drivers: ['Leather processing', 'Finished goods export', 'Value-added manufacturing'] },
  site: 'https://www.lrg-botswana-leather.com',
};

export const SQUASH = {
  site: 'https://www.lrgsquash.com',
  email: 'dreadsports.baltimore@gmail.com',
  intro: 'Dreadsports and NJSC now come together under one name as LRG Squash, offering high-quality coaching and training for players of all ages and skill levels across Baltimore and Princeton.',
  locations: [
    { city: 'Baltimore, MD', items: ['Junior Programs', 'Adult Squash', 'Court Reservation', 'Summer Camps'], link: 'https://lrgsquash.com/junior-programs' },
    { city: 'Princeton, NJ', items: ['Memberships', 'Junior Programs', 'Adult Squash'], link: 'https://lrgsquash.com/memberships' },
  ],
  academy: [
    { level: 'Beginner', text: 'Players develop racquet and motor skills while creating a passion for the game: grip, swing, preparation and hand-eye coordination.' },
    { level: 'Intermediate', text: 'Skills fine-tuned through drills, strength training and court movement, with scoring, match play and fitness.' },
    { level: 'Advanced / Elite', text: 'Game plans, strategic play and a winning mindset, with an emphasis on match play and collegiate squash opportunities.' },
  ],
  consulting: 'With over 20 years of experience working with junior players, parents and college coaches, LRG Squash guides families through the recruiting process to find schools that match each player\u2019s academic profile, athletic level and aspirations.',
  coaches: [
    { name: 'Lefika Ragontse', role: 'Founder and Director of Squash', points: ['Coached 16 Junior National Champions', 'Four time NCAA Champion', 'USA U25 Champion', '16 time Botswana National Champion'] },
    { name: 'Lazarus Chilufya', role: 'Coach', points: ['Won 7 Pro Squash Association tournaments', '20 international titles across Africa and the US', 'Zambia No. 1 ranked player for 15 years', 'U.S. Open Defending Champion, 35+'] },
    { name: 'Omar Ali', role: 'Coach', points: ['Played for the Dickinson College Men\u2019s Squash Team'] },
    { name: 'Ned Sparrow', role: 'Coach', points: ['Level 2 certified US Squash coach', 'Coached Bryn Mawr JV, Loyola and McDonogh MS'] },
  ],
};

export const BETTERIDGE = {
  years: '2014 to 2016',
  name: 'Betteridge',
  descriptor: 'Wall Street\u2019s Jeweler',
  founded: '1897',
  hq: 'Greenwich, Connecticut',
  article: 'https://westfaironline.com/fairfield/betteridge-relocates-on-greenwich-avenue/',
  quote: 'We\u2019re sitting at the table with the big boys. There are not too many players.',
  quoteBy: 'Terry Betteridge, Owner of Betteridge, on buying rough diamonds in Botswana',
  facts: [['Founded', '1897'], ['Headquarters', 'Greenwich, Connecticut'], ['Boutiques', 'Aspen, Vail, Palm Beach'], ['Partnership', '2014 to 2016']],
};

export const MILESTONES = [
  { year: '2014', title: 'LRG Holdings founded', text: 'Established in Gaborone by Lefika Ragontse to connect Botswana\u2019s industries to global markets.' },
  { year: '2014', title: 'Betteridge partnership begins', text: 'LRG partners with Betteridge, the 1897 Greenwich jeweler known as Wall Street\u2019s Jeweler, opening a Botswana office for rough diamond sourcing.' },
  { year: '2015', title: 'Terry Betteridge in Gaborone', text: 'Betteridge\u2019s owner travels to Botswana to bid at government rough diamond auctions alongside the world\u2019s largest buyers.' },
  { year: '2016', title: 'Partnership concludes', text: 'Two years of auction bidding and rough processing establish LRG\u2019s dedicated, mandate-based auction representation.' },
  { year: '2016', title: 'LRG Luxury opens Versace Jeans', text: 'In 2016, LRG Luxury opened a Versace Jeans boutique at Melrose Arch in Johannesburg, South Africa. The boutique was sold in 2024.' },
  { year: '2023', title: 'GemEx', text: 'LRG Holdings established its relationship with GemEx Systems to bring scientific light-performance analysis and advanced diamond-identification technology to Botswana Brilliance.' },
  { year: '2024', title: 'iTraceiT', text: 'LRG Holdings partnered with iTraceiT to provide digital traceability and chain-of-custody capabilities for Botswana-origin diamonds.' },
  { year: '2025', title: 'Botswana Brilliance', text: 'LRG launches Botswana Brilliance, a verified origin and identity certificate for Botswana diamonds.' },
  { year: '2026', title: 'Nobel Laureate in Botswana', text: 'In March 2026 LRG hosts Professor James A. Robinson, 2024 Nobel Laureate in Economic Sciences, at the University of Botswana, Parliament and on the diamond floor.' },
  { year: '2026', title: 'Sarine', text: 'LRG Holdings established its relationship with Sarine Technologies as part of the Botswana Brilliance verification and light-performance framework.' },
];

export const LRG_LUXURY = {
  title: 'LRG Luxury',
  store: 'Versace Jeans, Melrose Arch',
  city: 'Johannesburg, South Africa',
  year: '2016 to 2024',
  text: 'In 2016, LRG Luxury opened a Versace Jeans boutique at Melrose Arch in Johannesburg. Melrose Arch is one of Africa\u2019s most prestigious mixed use precincts, and the boutique brought the bold Italian house to a discerning South African clientele. The boutique was sold in 2024. The venture sharpened LRG\u2019s understanding of luxury consumers, brand stewardship and premium retail, the same instincts that now guide how Botswana\u2019s diamonds are presented to the world.',
};


export const PROGRAMMES = [
  {
    region: 'United States',
    title: 'Squash in Baltimore and Princeton',
    image: 'usTeam',
    caption: 'LRG Squash juniors together after training in the United States.',
    text: 'Through LRG Squash, junior players train year round in Baltimore and Princeton, competing on the US junior circuit and progressing to varsity squash at leading universities. Champions coach the programme and college recruitment consulting guides every family through the pathway.',
    points: ['Junior academy from beginner to elite', 'Summer camps and tournament coaching', 'College recruitment consulting', 'Varsity placements at Ivy League and NESCAC schools'],
  },
  {
    region: 'Botswana',
    title: 'Squash and Soccer across Botswana',
    image: 'communitySoccerBotswana',
    focus: 'center 45%',
    caption: 'A community soccer session in Botswana with LRG Squash Foundation coaches.',
    text: 'In Botswana the Foundation runs squash and soccer programmes that reach children where they are, on village pitches and community courts. Alongside the athletes, we train and certify local coaches so that every programme is led by Batswana and lives on in its community.',
    points: ['Grassroots squash and soccer sessions', 'Coach development and certification', 'Equipment, kit and court access', 'Scholarship pathways to US universities'],
  },
];

export const ZOE = {
  name: 'Zoe Diamonds',
  person: 'Ada Thela',
  role: 'Founder and Managing Director, Zoe Diamonds',
  quote: 'With LRG Holdings and iTraceiT, we\u2019ve gained trust, attracted new clients, and strengthened our advocacy for natural diamonds from Botswana.',
  intro: 'At LRG Holdings, our focus is on protecting the next phase of diamonds by ensuring that Botswana leads in traceability and transparency. Our goal is a framework where every diamond connected to Botswana carries proof of origin, integrity and value, so that clients, retailers and consumers can each choose their platform while still being anchored to Botswana\u2019s story.',
  body: 'It is with this vision in mind that we proudly welcomed Zoe Diamonds into the Botswana Brilliance ecosystem. LRG introduced Ada Thela and her team to iTraceiT traceability training, equipping a Botswana owned diamond business with the tools to document every stone\u2019s journey and to compete on trust in the global market.',
};

export const FOOTPRINT = [
  { continent: 'Africa', places: [
    { city: 'Gaborone, Botswana', role: 'Headquarters. Diamonds, Botswana Brilliance, education partnerships, Foundation programmes' },
    { city: 'Lobatse, Botswana', role: 'LRG Leather Botswana, SEZA licensed tanning and manufacturing platform' },
    { city: 'Johannesburg, South Africa', role: 'LRG Luxury, Versace Jeans boutique at Melrose Arch, 2016 to 2024' },
  ] },
  { continent: 'North America', places: [
    { city: 'Baltimore, Maryland', role: 'LRG Squash junior academy, camps and college consulting' },
    { city: 'Princeton, New Jersey', role: 'LRG Squash memberships and junior programmes' },
    { city: 'Chicago, Illinois', role: 'Signed University of Botswana and University of Chicago Harris School of Public Policy partnership' },
    { city: 'Greenwich, Connecticut', role: 'Betteridge diamond partnership, 2014 to 2016' },
  ] },
  { continent: 'Europe', places: [
    { city: 'San Romano, Italy', role: 'Italprogetti tannery engineering and plant design' },
    { city: 'Tuscany, Italy', role: 'Leather cluster technical benchmark and Italian manufacturing partners' },
  ] },
];
